import { APPLICATIONS, INITIAL_ADD_DELETE_VERSION } from '../constant/constant';
import { selectedVersionPayload } from '../constant/types';

const initialState = {
  sourceVersion: INITIAL_ADD_DELETE_VERSION,
  sourceLoading: false,
  sourceAppChoice: APPLICATIONS.STUDIOBFF,
  sourceRegion: 'us-dev',
  destinationAppChoice: APPLICATIONS.BIITENSHELL,
  destinationVersion: INITIAL_ADD_DELETE_VERSION,
  destinationLoading: false,
};

export const addDeleteVersionGroupsReducer = (
  state = initialState,
  action: { type: string; payload: string | selectedVersionPayload | boolean },
) => {
  switch (action.type) {
    case 'SOURCE_APPLICATION':
      return { ...state, sourceAppChoice: action.payload };
    case 'SOURCE_REGION':
      return { ...state, sourceRegion: action.payload };
    case 'SOURCE_VERSION':
      return { ...state, sourceVersion: action.payload };
    case 'SOURCE_LOADING':
      return { ...state, sourceLoading: action.payload };
    case 'DESTINATION_LOADING':
      return { ...state, destinationLoading: action.payload };
    case 'DESTINATION_VERSION':      
      return { ...state, destinationVersion: action.payload };
    case 'DESTINATION_APPLICATION':
      return { ...state, destinationAppChoice: action.payload };
    default:
      return state;
  }
};
